import cx from "classnames";
import styles from "./NavigationControl.module.scss";

export class NavigationControl implements mapboxgl.IControl {
  private _map: any;
  private readonly _container: HTMLDivElement | null = null;
  private readonly _nextButton: HTMLDivElement | null = null;
  private readonly _previousButton: HTMLDivElement | null = null;

  private readonly _onNextEvent: () => void;

  private readonly _onPreviousEvent: () => void;
  private readonly _getNavigatorStatus: () => {
    hasNext: boolean;
    hasPrevious: boolean;
  };
  private _navigatorStatus: {
    hasNext: boolean;
    hasPrevious: boolean;
  };

  constructor(
    onNextClicked: () => void,
    onPreviousClicked: () => void,
    getNavigatorStatus: any
  ) {
    this._onNextEvent = onNextClicked;
    this._onPreviousEvent = onPreviousClicked;
    this._getNavigatorStatus = getNavigatorStatus;

    this._navigatorStatus = getNavigatorStatus();

    if (typeof window !== "undefined") {
      this._container = document.createElement("div");
      this._container.className = cx(styles.container, "mapboxgl-ctrl");

      const arrowLeft = this._getArrowSVG();

      const arrowRight = this._getArrowSVG();
      arrowLeft.classList.add(styles.arrowLeft);

      this._nextButton = this._createButton();
      this._nextButton.appendChild(arrowRight);

      this._previousButton = this._createButton();
      this._previousButton.appendChild(arrowLeft);

      this._container.append(this._previousButton, this._nextButton);
    }
  }

  onAdd(map: mapboxgl.Map): HTMLElement {
    this._map = map;

    this._nextButton?.addEventListener("click", this._onNext.bind(this));
    this._previousButton?.addEventListener(
      "click",
      this._onPrevious.bind(this)
    );

    return this._container!;
  }

  onRemove() {
    this._nextButton?.removeEventListener("click", this._onNext);
    this._previousButton?.removeEventListener("click", this._onPrevious);

    this._container?.parentNode?.removeChild(this._container);
    this._map = undefined;
  }

  private _createButton() {
    const btn = document.createElement("div");
    btn.className = styles.button;

    return btn;
  }

  private _onNext() {
    this._onNextEvent();
    this._toggleButtonsStatus();
  }

  private _onPrevious() {
    this._onPreviousEvent();
    this._toggleButtonsStatus();
  }

  private _toggleButtonsStatus() {
    this._navigatorStatus = this._getNavigatorStatus();

    if (this._navigatorStatus.hasNext) {
      this._nextButton?.classList.remove("disabled");
    } else {
      this._nextButton?.classList.add("disabled");
    }

    if (this._navigatorStatus.hasPrevious) {
      this._previousButton?.classList.remove("disabled");
    } else {
      this._previousButton?.classList.add("disabled");
    }
  }

  protected _getArrowSVG() {
    // Create the SVG element
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "9");
    svg.setAttribute("height", "14");
    svg.setAttribute("viewBox", "0 0 9 14");
    svg.setAttribute("fill", "none");

    // Create the path element
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute(
      "d",
      "M2 0.929688L0.5 2.42969L5.07031 7L0.5 11.5703L2 13.0703L8.07031 7L2 0.929688Z"
    );
    path.setAttribute("fill", "#575B63");

    // Append the path element to the SVG element
    svg.appendChild(path);

    return svg;
  }

  refresh() {
    this._toggleButtonsStatus();
  }
}
